import { Text } from "@mantine/core";
import type { MarkdownToJSX } from "markdown-to-jsx";

export const baseOverride: MarkdownToJSX.Overrides = {
    Text: {
        component: Text,
    },
};
